import { render } from "./PhysicianLayout.vue?vue&type=template&id=e286484c"
import script from "./PhysicianLayout.vue?vue&type=script&lang=js"
export * from "./PhysicianLayout.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__